// Vanilla CSS for OpenEndedActivityMaterialContent redesign (Playful Frost).
// Prefix: oe2-
// Injected locally via <style>{oe2Styles}</style> inside the component.
export const oe2Styles = `
  /* ── wrapper ── */
  .oe2-root {
    display: flex;
    flex-direction: column;
    gap: var(--space-3, 12px);
    font-family: var(--font-sans);
  }

  /* ── text answer area ── */
  .oe2-area {
    width: 100%;
    min-height: 200px;
    resize: vertical;
    border-radius: var(--rad-catchup-large);
    background: var(--catchup-white);
    border: 1.5px solid var(--catchup-blue-100);
    padding: 16px;
    font-family: var(--font-sans);
    font-size: var(--fs-lg);
    color: var(--text-primary);
    line-height: 1.6;
    box-sizing: border-box;
    transition: border-color 150ms ease, box-shadow 150ms ease;
    outline: none;
  }
  .oe2-area::placeholder {
    color: var(--text-muted);
  }
  .oe2-area:focus {
    border-color: var(--catchup-blue);
    box-shadow: 0 0 0 3px rgba(87, 194, 211, 0.18);
  }

  /* ── footer: char count + hint ── */
  .oe2-foot {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: var(--fs-sm);
    color: var(--text-muted);
    flex-wrap: wrap;
  }
  .oe2-foot-sep {
    opacity: 0.4;
  }
  .oe2-hint-avatar {
    width: 20px; height: 20px; flex-shrink: 0;
    border-radius: 50%;
    object-fit: cover; object-position: center;
  }
  .oe2-hint {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  /* ── submitted / checked note ── */
  /* design (spv-oe-area checked): a WHITE card carrying the "submitted,
     teacher/AI grades" notice; the learner's answer echoes below it */
  .oe2-submitted {
    min-height: auto;
    border-radius: var(--rad-catchup-large);
    background: var(--catchup-white);
    border: 1.5px solid var(--catchup-blue-100);
    padding: 16px 18px;
    font-size: var(--fs-lg);
    color: var(--text-primary);
    line-height: 1.6;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .oe2-submitted-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-weight: 600;
    color: var(--text-secondary);
  }
  .oe2-submitted-icon {
    flex-shrink: 0;
    font-size: var(--fs-xl);
    line-height: 1.4;
    color: var(--color-success-text, #2d7a4a);
  }
  .oe2-submitted-text {
    flex: 1;
    font-weight: 600;
  }

  /* ── upload-row (image/video/file) ── */
  .oe2-upload-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    column-gap: 1rem;
    flex-wrap: wrap;
    gap: 10px;
  }
  .oe2-upload-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 6px;
    font-size: var(--fs-sm);
    font-weight: 600;
    color: var(--brand-dark);
    padding: 8px 14px;
    border-radius: var(--rad-catchup-full);
    background: var(--catchup-white);
    border: 1.5px solid var(--catchup-blue-100);
    transition: border-color 150ms, box-shadow 150ms;
  }
  .oe2-upload-option:hover {
    border-color: var(--catchup-blue);
    box-shadow: 0 4px 10px -4px rgba(87, 194, 211, 0.3);
  }
  .oe2-hidden {
    display: none;
  }

  /* ── media preview (image/video) ── */
  .oe2-media-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .oe2-media-img {
    width: 100%;
    border-radius: var(--rad-catchup-large);
    max-height: 50vh;
    object-fit: contain;
    border: 1px solid var(--catchup-blue-100);
  }
  .oe2-media-video {
    width: 100%;
    border-radius: var(--rad-catchup-large);
    max-height: 50vh;
    border: 1px solid var(--catchup-blue-100);
  }

  /* ── upload status bar ── */
  .oe2-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
  }
  .oe2-status-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: var(--fs-base);
    color: var(--text-secondary);
  }
  .oe2-status-row-err {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: var(--fs-base);
    color: var(--color-error-text, #c0392b);
  }
  .oe2-status-mt {
    margin-top: 1rem;
  }

  /* ── audio area ── */
  .oe2-audio-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .oe2-audio-inner {
    width: 100%;
    max-width: 480px;
  }
  .oe2-audio-box {
    height: 56px;
    margin-top: 0.5rem;
  }
  .oe2-audio {
    height: 100%;
    width: 100%;
    border-radius: var(--rad-catchup-xlarge);
  }
  .oe2-audio-col {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .oe2-audio-row {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
  .oe2-audio-restart {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  /* recording status pill */
  .oe2-rec-status {
    border-width: 1px;
    border-style: solid;
    border-radius: var(--rad-catchup-xlarge);
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 1rem;
    text-align: center;
  }
  .oe2-rec-status--blue {
    border-color: var(--catchup-dark-blue);
  }
  .oe2-rec-status--orange {
    border-color: var(--catchup-orange);
  }
  .oe2-rec-status--red {
    border-color: var(--catchup-red);
  }
  .oe2-rec-status-text--2xl {
    font-size: var(--fs-2xl);
    color: var(--catchup-dark-blue);
  }
  .oe2-rec-status-text--xl-orange {
    font-size: var(--fs-xl);
    color: var(--catchup-orange);
  }
  .oe2-rec-status-text--xl-red {
    font-size: var(--fs-xl);
    color: var(--catchup-red);
  }
  .oe2-rec-status-text--xl-blue {
    font-size: var(--fs-xl);
    color: var(--catchup-dark-blue);
  }

  /* recording tap boxes */
  .oe2-rec-box {
    width: 160px;
    cursor: pointer;
    transition: opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .oe2-rec-box--visible { opacity: 1; }
  .oe2-rec-box--hidden  { opacity: 0; pointer-events: none; }
  .oe2-rec-icon {
    width: 100%;
  }
  .oe2-rec-complete {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  /* modal helpers (phone upload QR) */
  .oe2-modal-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .oe2-modal-half {
    width: 50%;
  }
  .oe2-qr-pad {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .oe2-instructions-pad {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .oe2-instructions-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .oe2-phone-wait-hint {
    margin-top: var(--space-3);
    color: var(--catchup-red);
    font-size: var(--fs-sm);
  }

  /* responsive */
  @media (max-width: 600px) {
    .oe2-upload-row {
      justify-content: flex-start;
    }
    .oe2-modal-half {
      width: 100%;
    }
  }
`;
